<div [formGroup]="maneuverForm" class="relative flex h-full flex-col">
	<div class="past-comments flex-1 overflow-x-hidden px-3 pb-1 pt-3">
		@for (c of otherTrainingComments; track c; let i = $index) {
			<div class="grid grid-cols-6 gap-2 text-[85%] uppercase lg:grid-cols-4">
				<span class="col-span-5 line-clamp-1 text-ellipsis break-all lg:col-span-3">{{ c.comment }}</span>
			</div>
		}
	</div>
	<div class="flex justify-end gap-1 px-3 pb-3 pt-1">
		<button
			(click)="onOtherTrainingCommentsAdded()"
			class="size-6 rounded-sm bg-red pt-1 text-center text-white lg:size-8"
			matTooltip="Comment"
		>
			@if (otherTrainingComments.length === 0) {
				<mat-icon class="text-xs lg:text-base">comment</mat-icon>
			}
			@if (otherTrainingComments.length !== 0) {
				<mat-icon class="text-xs lg:text-base">edit</mat-icon>
			}
		</button>
	</div>
</div>
